<div class="formContainer d-flex justify-content-center">
  <form [formGroup]="form">
    <div class="row">
      <mat-form-field>
        <mat-label>Type de bien</mat-label>
        <mat-select formControlName="type" required placeholder="">
          <mat-option *ngFor="let type of propertyTypes" [value]="type">{{
            propertyTypesName[type]
          }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Description</mat-label>
        <input
          matInput
          placeholder=""
          type="text"
          required
          formControlName="name"
        />
        <mat-error>
          <span *ngIf="form_name.hasError('required')"
            >Veuillez saisir une description</span
          >
          <span *ngIf="form_name.hasError('maxlength')"
            >La description ne doit pas dépasser 50 caractères</span
          >
        </mat-error>
      </mat-form-field>
    </div>

    <div *ngIf="withAddressSearch" class="row">
      <mat-form-field class="w-100">
        <mat-label>Adresse</mat-label>
        <input
          type="text"
          placeholder="Rechercher une adresse"
          matInput
          [required]="withAddressRequired"
          [matAutocomplete]="autoAddress"
          formControlName="searchAddress"
          (input)="doSearchAddress()"
        />
        <mat-hint>5 caractères minimum</mat-hint>
        <mat-error *ngIf="form_searchAddress.hasError('minlength')">
          Veuillez saisir au moins 5 caractères
        </mat-error>
        <mat-error
          *ngIf="
            !form_searchAddress.hasError('minlength') &&
            form_searchAddress.hasError('noAddressSelected')
          "
        >
          Aucune adresse sélectionnée
        </mat-error>
        <mat-error *ngIf="form_searchAddress.hasError('noResult')">
          Adresse non trouvée. Veuillez affiner la saisie.
        </mat-error>
        <mat-icon
          *ngIf="apiAddressError"
          appTooltip="La connection a été interrompue. Vérifiez votre connection Internet."
          matSuffix
          color="warn"
          >warning</mat-icon
        >
        <mat-autocomplete
          #autoAddress="matAutocomplete"
          (optionSelected)="addressSelected($event.option.value)"
        >
          <mat-option
            *ngIf="searchAddressResults && searchAddressResults.length === 0"
            >Aucun résultat</mat-option
          >
          <mat-option
            *ngFor="let address of searchAddressResults"
            [value]="address"
          >
            {{ address.properties.label }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </form>
</div>
